import { Stack, styled } from '@mui/material'
import { Button } from '../../../../components'

const Container = styled(Stack)`
  gap: 10px;
  height: 100%;
`

const ListSection = styled(Stack)`
  gap: 10px;
  width: 100%;
  flex: 1;
  flex-direction: row;
  overflow: auto;
`

const PageActionsContainer = styled(Stack)`
  height: 96px;
  justify-content: center;
  padding: 0 20px;
`

const PageActionsButtons = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
`

const UpdateButton = styled(Button)`
  width: 244px;
`

export {
  Container,
  ListSection,
  PageActionsContainer,
  PageActionsButtons,
  UpdateButton,
}
